import type { Theme } from "../tokens";

/**
 * Warm daylight. Soft cards on sand, one terracotta accent, a peach-to-sage bar.
 *
 * Direction 11, chosen 2026-09-24 from the client's mockup. It is the only
 * direction with chrome — every other one is a drawn grid — so it is also the
 * only one that fills the chrome block rather than taking the flat fallbacks.
 */
export const aura: Theme = {
  id: "aura",
  name: "Aura",
  thesis: "Warm daylight. Soft cards on sand, one terracotta accent.",
  scheme: "light",
  colors: {
    ground: "#F2EADC",
    surface: "#FDF8F0",
    raised: "#D9E4DB",
    ink: "#33291F",
    dim: "#6B5F54",
    rule: "#E4DACA",
    lattice: "#EFE6D6",
    focus: "#B34A1F",
    inbox: "#B34A1F",
    feed: "#4A6553",
    paperTrail: "#6B5F54",
    screener: "#8A4A6B",
  },
  chrome: {
    from: "#F6C9A8",
    to: "#BFD6C6",
    accent: "#B34A1F",
    onAccent: "#FFF7F0",
    tag: "#F5DCCE",
    tagInk: "#7A3312",
  },
  type: {
    sans: "'Nunito', system-ui, sans-serif",
    mono: "'IBM Plex Mono', ui-monospace, monospace",
    googleFonts: "Nunito:wght@400;600;700;800&family=IBM+Plex+Mono:wght@400;500",
    tracking: "0",
  },
  density: {
    // The card carries three lines and a pill row, so the row token is the
    // card's minimum height rather than a fixed one.
    row: 92,
    primary: 17,
    secondary: 15,
    meta: 13,
    listWidth: 720,
    rail: 260,
    radius: 22,
    lineHeight: 1.4,
  },
  markers: {
    inbox: "■",
    feed: "▤",
    paperTrail: "▭",
    screener: "▲",
  },
};
